import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import Page1 from "./Pages/Page1";
import {
  caaqmsDataType,
  CurrentCaaqmsData,
  CurrentCaaqmsRes,
  dataType,
} from "./Pages/type";
import Page3 from "./Pages/Page3";
import Page2 from "./Pages/Page2";
import { imageArray } from "./assets/data";
import PageNew1 from "./Pages/PageNew1";
import PageNew3 from "./Pages/PageNew3";

export default function App() {
  const [AQIInfo, setAQIInfo] = useState<dataType | undefined>();

  const swiperRef = useRef<any>(null);
  const [currentTempData, setCurrentTempData] = useState<
    CurrentCaaqmsData | undefined
  >();

  const devId = Number(window?.location?.pathname?.split("/")[1]) || 1;

  const [AQIColor, setAPIColor] = useState({
    color: "#FFF500",
    type: "Moderate",
  });
  const getColorCodeHandler = ({ aqi }: { aqi: number }) => {
    if (aqi && aqi < 50) {
      setAPIColor({ color: "#00af50", type: "Good" });
    }
    if (aqi >= 50 && aqi <= 100) {
      setAPIColor({ color: "#92d14f", type: "Satisfactory" });
    }
    if (aqi >= 101 && aqi <= 200) {
      setAPIColor({ color: "#fffd03", type: "Moderate" });
    }
    if (aqi >= 201 && aqi <= 300) {
      setAPIColor({ color: "#fd9a00", type: "Poor" });
    }
    if (aqi >= 301 && aqi <= 400) {
      setAPIColor({ color: "#cd1d20", type: "Very Poor" });
    }
    if (aqi >= 401) {
      setAPIColor({ color: "#bd0100", type: "Severe" });
    }
  };

  const GetInformationHandler = async ({}: {}) => {
    if (!devId) return;
    try {
      await fetch(
        ` https://caaqms.wbpcb.wtlprojects.com:9100/v1.0/sens/real/get_24h_aqi?station_id=${devId}`
      )
        .then((response) => response.json())
        .then((result: caaqmsDataType) => {
          if (result?.data) setAQIInfo(result?.data[0]);
          getColorCodeHandler({ aqi: result?.data[0]?.AQI });
        })
        .catch((error) => console.log(error));
    } catch (error) {}
  };

  const GetCurrentTemp = async () => {
    if (!devId) return;
    try {
      await fetch(
        `https://caaqms.wbpcb.wtlprojects.com:9100/v1.0/sens/real/get_current?station_id=${devId}`
      )
        .then((response) => response.json())
        .then((result: CurrentCaaqmsRes) => {
          if (result?.data) setCurrentTempData(result?.data);
        })
        .catch((error) => console.log(error));
    } catch (error) {}
  };

  useEffect(() => {
    const fetchData = () => {
      GetInformationHandler({});
    };
    fetchData();

    const intervalId = setInterval(fetchData, 30 * 60 * 1000); // 10 minutes in milliseconds
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchData = () => {
      GetCurrentTemp();
    };
    fetchData();

    const intervalId = setInterval(fetchData, 5 * 60 * 1000); // 10 minutes in milliseconds
    return () => clearInterval(intervalId);
  }, []);

  const handleSlideChange = (swiper: any) => {
    const currentIndex = swiper.realIndex;
    const delay = currentIndex === 0 ? 20000 : devId === 6 ? 10000 : 5000; // 20s for first slide, 5s for rest
    swiper.params.autoplay.delay = delay;
    swiper.autoplay.start();
  };

  return (
    <div className={` ${devId === 6 ? "-ml-9" : "ml-0"}`}>
      <Swiper
        ref={swiperRef}
        onSwiper={(swiper: any) => (swiperRef.current = swiper)}
        onSlideChange={handleSlideChange}
        autoplay={{
          delay: 20000,
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper bg-[#181818]"
      >
        <SwiperSlide>
          {devId === 6 ? (
            <Page1
              devId={devId}
              AQIInfo={AQIInfo}
              AQIColor={AQIColor}
              currentTempData={currentTempData}
            />
          ) : (
            <PageNew1
              devId={devId}
              AQIInfo={AQIInfo}
              AQIColor={AQIColor}
              currentTempData={currentTempData}
            />
          )}
        </SwiperSlide>

        {devId === 6 &&
          imageArray.map((item) => (
            <SwiperSlide key={item.id}>
              <Page2 key={item.id} src={item.src} />
            </SwiperSlide>
          ))}
        <SwiperSlide>{devId === 6 ? <Page3 /> : <PageNew3 />}</SwiperSlide>
      </Swiper>
    </div>
  );
}
